import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TRAINERS_POST_REQUEST = 'POST_TRAINERS_REQUEST';
export const TRAINERS_POST_FAILURE = 'POST_TRAINERS_FAILURE';
export const TRAINERS_POST_SUCCESS = 'POST_TRAINERS_SUCCESS';

export const postTrainer = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.TRAINERS.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Trainer successfully  added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {
        type: TRAINERS_POST_REQUEST,
    }
};

const postFailure = error => {
    return {
        type: TRAINERS_POST_FAILURE,
        error,
    }
};

const postSuccess = trainer => {
    return {
        type: TRAINERS_POST_SUCCESS,
        trainer,
    }
};